function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { TextTrackMimeType } from '../../core/player/text-track-mime-type';
import { ShakaPlayerEngineSubtitles } from './shaka-player-engine-subtitles';
import { ShakaTextTracksManager } from './shaka-text-tracks-manager';
export var SafariShakaTextTracksManager = /*#__PURE__*/ function(ShakaTextTracksManager) {
    "use strict";
    _inherits(SafariShakaTextTracksManager, ShakaTextTracksManager);
    function SafariShakaTextTracksManager(player, safariConfig) {
        _class_call_check(this, SafariShakaTextTracksManager);
        var _this;
        _this = _call_super(this, SafariShakaTextTracksManager, [
            player,
            safariConfig
        ]), _define_property(_this, "safariConfig", void 0), _define_property(_this, "cachedVideoPlayerTextTracks", void 0), _define_property(_this, "trackCueChangeHandler", void 0), _this.safariConfig = safariConfig, _this.cachedVideoPlayerTextTracks = null, _this.trackCueChangeHandler = function(e) {
            var videoElement = _this.player.getMediaElement();
            if (!videoElement) {
                return;
            }
            var activeCues = e.target.activeCues;
            for(var i = 0; i < activeCues.length; i++){
                var // On Safari, the subtitleHandler is not controlled by the player but by cvsdk
                // This is because the player simply ignore and destroy this object when it's on Safari, but as it have all the subtitles rules we are using it by cvsdk to control the subtitles
                _this_config_textDisplayer, _this_config_textDisplayer1, _this_config_textDisplayer2;
                // Sometimes shaka fires a cue as having the end time as the content duration, making it remaining during all content play
                // Made this workaround to make sure that only adds this cues when the content is really close to the end.
                if (_this.currentPosition < videoElement.duration - 5 && activeCues[i].endTime === videoElement.duration) {
                    break;
                }
                // Sometimes we see cues without text. This seems to happen reliably on linear streams, when we get init fragments (eg: before ad transitions)
                if (!activeCues[i].text) {
                    break;
                }
                (_this_config_textDisplayer = _this.config.textDisplayer) === null || _this_config_textDisplayer === void 0 ? void 0 : _this_config_textDisplayer.append([
                    _this.adaptNativeShakaCue(activeCues[i])
                ]);
                (_this_config_textDisplayer1 = _this.config.textDisplayer) === null || _this_config_textDisplayer1 === void 0 ? void 0 : _this_config_textDisplayer1.remove(0, _this.currentPosition - 10);
                (_this_config_textDisplayer2 = _this.config.textDisplayer) === null || _this_config_textDisplayer2 === void 0 ? void 0 : _this_config_textDisplayer2.handlePositionChanged(_this.currentPosition);
            }
        };
        return _this;
    }
    _create_class(SafariShakaTextTracksManager, [
        {
            key: "hideNonForcedSubtitleTracks",
            value: /**
     * @override
     */ function hideNonForcedSubtitleTracks() {
                var videoElement = this.player.getMediaElement();
                if (!videoElement || this.isForcedActive()) {
                    return;
                }
                if (videoElement.textTracks) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = videoElement.textTracks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var track = _step.value;
                            track.mode = 'hidden';
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "isTextTrackVisible",
            value: /**
     * @override
     */ function isTextTrackVisible() {
                var _this_config_textDisplayer;
                return Boolean((_this_config_textDisplayer = this.config.textDisplayer) === null || _this_config_textDisplayer === void 0 ? void 0 : _this_config_textDisplayer.isTextVisible());
            }
        },
        {
            key: "postDisableSubtitlesHook",
            value: /**
     * @override
     */ function postDisableSubtitlesHook() {
                var /**
         * Shaka seems to be destroying `this.subtitlesHandler` on Safari for some reason and instead uses a native subtitle component which causes functionality and UI issues.
         * To avoid this we need to manually control `this.subtitlesHandler` on Safari by appending/removing cues as we go
         */ _this_config_textDisplayer, _this_config_textDisplayer1;
                var videoElement = this.player.getMediaElement();
                if (!videoElement) {
                    return;
                }
                (_this_config_textDisplayer = this.config.textDisplayer) === null || _this_config_textDisplayer === void 0 ? void 0 : _this_config_textDisplayer.remove(0, videoElement.duration);
                (_this_config_textDisplayer1 = this.config.textDisplayer) === null || _this_config_textDisplayer1 === void 0 ? void 0 : _this_config_textDisplayer1.setTextVisibility(false);
            }
        },
        {
            key: "postSetTextTrackHook",
            value: /**
     * @override
     */ function postSetTextTrackHook() {
                var /**
         * Shaka seems to be destroying `this.subtitlesHandler` on Safari for some reason and instead uses a native subtitle component which causes functionality and UI issues.
         * To avoid this we need to manually control `this.subtitlesHandler` on Safari by appending/removing cues as we go
         */ _this_config_textDisplayer, _this_config_textDisplayer1, _this_config_textDisplayer2;
                var videoElement = this.player.getMediaElement();
                if (!videoElement) {
                    return;
                }
                (_this_config_textDisplayer = this.config.textDisplayer) === null || _this_config_textDisplayer === void 0 ? void 0 : _this_config_textDisplayer.remove(0, videoElement.duration);
                (_this_config_textDisplayer1 = this.config.textDisplayer) === null || _this_config_textDisplayer1 === void 0 ? void 0 : _this_config_textDisplayer1.setTextVisibility(true);
                (_this_config_textDisplayer2 = this.config.textDisplayer) === null || _this_config_textDisplayer2 === void 0 ? void 0 : _this_config_textDisplayer2.handlePositionChanged(this.currentPosition);
            }
        },
        {
            key: "preDestroyHook",
            value: /**
     * @override
     */ function preDestroyHook() {
                this.removeVideoTextTracksListeners();
                this.cachedVideoPlayerTextTracks = null;
            }
        },
        {
            key: "preEmitTracksChangedHook",
            value: /**
     * @override
     */ function preEmitTracksChangedHook() {
                var videoElement = this.player.getMediaElement();
                if (!videoElement) {
                    return;
                }
                // Workaround to catch subtitles on Safari
                // Following a workaround tips from https://github.com/google/shaka-player/issues/2585
                if (this.cachedVideoPlayerTextTracks) {
                    this.removeVideoTextTracksListeners();
                }
                this.cachedVideoPlayerTextTracks = videoElement.textTracks;
                for(var i = 0; i < this.cachedVideoPlayerTextTracks.length; i++){
                    this.cachedVideoPlayerTextTracks[i].addEventListener('cuechange', this.trackCueChangeHandler);
                }
                if (this.selectedSubtitlesTrack) {
                    var activeTextTrack = this.getActiveTextTrack();
                    if (activeTextTrack && this.getTextTrackId(activeTextTrack) !== this.getTextTrackId(this.selectedSubtitlesTrack)) {
                        // Safari 15.2 can switch the active text track when the audio track is changed. If the active text
                        // track does not match the SDK's selected text track, switch back to the SDK's selected text track.
                        this.enableSubtitles("".concat(this.getTextTrackId(this.selectedSubtitlesTrack)));
                    }
                }
            }
        },
        {
            key: "preCacheHook",
            value: /**
     * @override
     */ function preCacheHook(tracks) {
                // This is a fix for an issue with mimeType identification in shaka.
                // This is workaround while we seek an alternative solution
                // https://github.com/shaka-project/shaka-player/issues/6233
                if (this.safariConfig.webVttOverride) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = tracks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var track = _step.value;
                            track.mimeType = TextTrackMimeType.WebVTT;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return tracks;
            }
        },
        {
            key: "adaptNativeShakaCue",
            value: function adaptNativeShakaCue(cue) {
                return ShakaPlayerEngineSubtitles.convertFromTextTrackCueToShakaCue(cue);
            }
        },
        {
            key: "removeVideoTextTracksListeners",
            value: function removeVideoTextTracksListeners() {
                if (!this.cachedVideoPlayerTextTracks) {
                    return;
                }
                for(var i = 0; i < this.cachedVideoPlayerTextTracks.length; i++){
                    this.cachedVideoPlayerTextTracks[i].removeEventListener('cuechange', this.trackCueChangeHandler);
                }
            }
        }
    ]);
    return SafariShakaTextTracksManager;
}(ShakaTextTracksManager);

//# sourceMappingURL=safari-shaka-text-tracks-manager.js.map